import React, { useState, useEffect } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { RawMaterialMasterProps } from './raw-material-master';
import help from './raw-material-master.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import rawMaterialMasterColumns from '../../types/rawMaterialMasterDataType';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useRawMaterialMasterHook(props: RawMaterialMasterProps) {
  useResourceBundle(translations, undefined, '15e8796b-6804-49ad-b9e8-ff6e72405265');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(rawMaterialMasterColumns());

  useEffect(() => {
    fetchAllDataGet_byApiName("GetMasterInputMaterials", apiUriMasterDataHttp()).then((data) => {
      setdataForColumns(data);

    }).catch((error)=>{
      console.log("Failed to Fetch Areas");
    });
  },[]);

  // useEffect(() => {
  //   const columnsAfterAddingOptions = columnNames.map((item)=> {
  //     if (item.accessor === 'isactive'){
  //       item.options =  [{display: 'ACTIVE', value: 'true'}, {display: 'INACTIVE', value: 'false'}] || [];
  //     }
  //     return(item);
  //   })
  //   setFinalColumns(columnsAfterAddingOptions);

  //   const modifiedJsonArray = dataForColumns?.map(item => {
  //     return {
  //         ...item,
  //         isactive: item.isactive ? "ACTIVE" : "INACTIVE"
  //       };
  //   });
  //   setconvertedDataForColumns(modifiedJsonArray);
  //   //console.log("column: ",columnsAfterAddingOptions);
  // },[dataForColumns]);


  const handleSaveAndDeleteFromTable = (data, returnType) =>{

    if(data.displayseq === ''){
      data.displayseq = 0;
      }

    data.displayseq = parseFloat(data.displayseq);

    if (data.isactive === '' ) {
      data.isactive = false ;
      }
    //console.log(data);

    sendAllDataPost_byApiNameAndData('AddMasterInputMaterials', data, apiUriMasterDataHttp())
      .then((response) => {
        if(response){
          fetchAllDataGet_byApiName("GetMasterInputMaterials", apiUriMasterDataHttp()).then((data) => {
            setdataForColumns(data);
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
      });

  };

  return {
    t,
    dataForColumns,
    columnNames,
    handleSaveAndDeleteFromTable
  };
}

export default useRawMaterialMasterHook;
